import {
  APIKeysSectionRoute,
  AccountSettingsRoute,
  AccountsListRoute,
  GeneralSectionRoute,
  PaymentMethodsSectionRoute,
  UsersSectionRoute,
} from 'pages/account/route';
import { CryptoPayoutCreateRoute, CryptoPayoutsListRoute } from 'pages/cryptoPayout/route';
import { CustomerViewRoute, CustomersListRoute } from 'pages/customers/route';
import { DocumentationRoute } from 'pages/documentation/route';
import {
  MerchantGeneralSectionRoute,
  MerchantPayoutReserveRoute,
  MerchantRefundAccountRoute,
  MerchantRefundAccountTransactionRoute,
  MerchantViewRoute,
  MerchantsListRoute,
  SettlementSectionRoute,
} from 'pages/merchant/route';
import { NotImplementedRoute } from 'pages/notImplemented/route';
import { OrderReceiptRoute, OrderViewRoute } from 'pages/orders/route';
import PaymentByLinkRoute from 'pages/paymentByLink/route';
import { PayoutViewRoute } from 'pages/payout/route';
import { ProfileRoute } from 'pages/profile/route';
import { PwcCustomerViewRoute, PwcCustomersListRoute } from 'pages/pwcCustomers/route';
import { PwcOrderListRoute, PwcOrderViewRoute } from 'pages/pwcOrders/route';
import { ReconciliationsListRoute, ReconciliationsViewRoute } from 'pages/reconciliations/route';
import { SettingsRoute, UsersSectionRoute as SettingsUsersSectionRoute } from 'pages/settings/route';

import { RouteSetup } from 'types/routing';

import { CryptoPayoutViewRoute } from '../../../pages/cryptoPayout/view';
import RoutePath from '../../path';
import { menuItems } from './menuItems';

export const AdminRouterSetup: RouteSetup = {
  availableRoutes: [
    {
      path: RoutePath.Ramp.Customers.Root,
      component: CustomersListRoute,
    },
    {
      path: RoutePath.Ramp.Customers.ById,
      component: CustomerViewRoute,
    },
    {
      path: RoutePath.Ramp.Orders.Root,
      component: NotImplementedRoute,
    },
    {
      path: RoutePath.Ramp.Orders.ById,
      component: OrderViewRoute,
    },
    {
      path: RoutePath.Ramp.Orders.ReceiptById,
      component: OrderReceiptRoute,
    },
    {
      path: RoutePath.Pwc.PaymentByLink.Root,
      component: PaymentByLinkRoute,
    },
    {
      path: RoutePath.Pwc.Payouts.ById,
      component: PayoutViewRoute,
    },
    {
      path: RoutePath.Ramp.Accounts.List,
      component: AccountsListRoute,
    },
    {
      path: RoutePath.Pwc.Customers.Root,
      component: PwcCustomersListRoute,
    },
    {
      path: RoutePath.Pwc.Customers.ById,
      component: PwcCustomerViewRoute,
    },
    {
      path: RoutePath.Pwc.Orders.Root,
      component: PwcOrderListRoute,
    },
    {
      path: RoutePath.Pwc.Orders.ById,
      component: PwcOrderViewRoute,
    },
    {
      path: RoutePath.Pwc.Orders.ReceiptById,
      component: NotImplementedRoute,
    },
    {
      path: RoutePath.Pwc.Accounts.Root,
      component: MerchantsListRoute,
    },
    {
      path: RoutePath.Pwc.RefundAccountTransactions.ById,
      component: MerchantRefundAccountTransactionRoute,
      defaultRedirectRoute: RoutePath.Pwc.AccountSettings.General,
    },
    {
      path: RoutePath.Pwc.Accounts.ById,
      component: MerchantViewRoute,
      defaultRedirectRoute: RoutePath.Pwc.Accounts.General,
      children: [
        {
          path: RoutePath.Pwc.Accounts.General,
          component: MerchantGeneralSectionRoute,
        },
        {
          path: RoutePath.Pwc.AccountSettings.APIKeys,
          component: APIKeysSectionRoute,
        },
        {
          path: RoutePath.Pwc.AccountSettings.Settlement,
          component: SettlementSectionRoute,
        },
        {
          path: RoutePath.Pwc.AccountSettings.Users,
          component: UsersSectionRoute,
        },
        {
          path: RoutePath.Pwc.AccountSettings.RefundAccount,
          component: MerchantRefundAccountRoute,
        },
        {
          path: RoutePath.Pwc.AccountSettings.PayoutReserve,
          component: MerchantPayoutReserveRoute,
        },
      ],
    },
    {
      path: RoutePath.CryptoPayout.Payouts.Root,
      component: CryptoPayoutsListRoute,
    },
    {
      path: RoutePath.CryptoPayout.Payouts.ById,
      component: CryptoPayoutViewRoute,
    },
    {
      path: RoutePath.CryptoPayout.PayoutByLink.Root,
      component: CryptoPayoutCreateRoute,
    },
    {
      path: RoutePath.AccountSettings.ById,
      component: AccountSettingsRoute,
      defaultRedirectRoute: RoutePath.AccountSettings.General,
      children: [
        {
          path: RoutePath.AccountSettings.General,
          component: GeneralSectionRoute,
        },
        {
          path: RoutePath.AccountSettings.PaymentMethods,
          component: PaymentMethodsSectionRoute,
        },
        {
          path: RoutePath.AccountSettings.APIKeys,
          component: APIKeysSectionRoute,
        },
        {
          path: RoutePath.AccountSettings.Users,
          component: UsersSectionRoute,
        },
      ],
    },
    {
      path: RoutePath.GeneralSettings.Root,
      component: SettingsRoute,
      defaultRedirectRoute: RoutePath.GeneralSettings.Users,
      children: [
        {
          path: RoutePath.GeneralSettings.Users,
          component: SettingsUsersSectionRoute,
        },
        {
          path: RoutePath.GeneralSettings.Reconciliations,
          component: ReconciliationsListRoute,
        },
        {
          path: RoutePath.GeneralSettings.ReconciliationsById,
          component: ReconciliationsViewRoute,
        },
      ],
    },
    {
      path: RoutePath.Documentation.Root,
      component: DocumentationRoute,
    },
    {
      path: RoutePath.Profile.Root,
      component: ProfileRoute,
    },
  ],
  menuItems,
  defaultLoginRedirectRoute: RoutePath.Pwc.Orders.Root,
};

export default AdminRouterSetup;
